import MUIListItemIcon from '@mui/material/ListItemIcon';
import MUIListItemText from '@mui/material/ListItemText';
import { styled } from '../../theme/styled';

export * from './list';
export * from './item';
export const ListItemIcon = styled(MUIListItemIcon)({ minWidth: '32px!important' });
export const ListItemText = MUIListItemText;
export type { MenuSize } from './model';
